import { BaseResponseBody, CommonJsonResponseWithData, ErrorJsonResponse, ErrorResponseBody, ResponseBody } from "../common/model/objectTypes";
import { CommonRequestHeader, RequestHeaderWithCallback } from "../common/model/requestHeaders";
import { CommonJsonResponse } from "../common/model/ssr/jsonResponse";
import { baseErrorResponseParameter, baseResponseParameter, commonResponseParameter, requestHeaderParameter } from "./apiParameters";

export const commonRequestHeader: CommonRequestHeader = {
  authorization: requestHeaderParameter.authorization,
}

export const requestHeaderWithCallback: RequestHeaderWithCallback = {
  authorization: requestHeaderParameter.authorization,
  callbackApiKey: requestHeaderParameter.callbackApiKey,
}

export const baseResponseBody: BaseResponseBody = {
  status: baseResponseParameter.status,
  message: baseResponseParameter.message,
  correlationId: baseResponseParameter.correlationId,
  isSuccess: baseResponseParameter.isSuccess,
}

export const commonResponseBody: ResponseBody = {
  ...baseResponseBody,
  data: {
    ifData: commonResponseParameter.ifData
  }
}

export const createCommonJsonResponse = (status: number): CommonJsonResponse => ({
  status,
  isSuccess: true,
  correlationId: "string",
  message: "string",
});

export const createCommonJsonResponseWithData = (status: number): CommonJsonResponseWithData => ({
  ...createCommonJsonResponse(status),
  data:"string",
});

export const errorJsonResponse: ErrorJsonResponse = {
  code: "string",
  message: "string"
}

export const errorResponseBody: ErrorResponseBody = {
  data: {
    code: baseErrorResponseParameter.code,
    errorMessage: baseErrorResponseParameter.message,
  },
}